import projection from '../generated/pwd203f1.json';
import { AcceptanceManifest } from '../types';
export const pwd203f1AcceptanceManifest = projection as AcceptanceManifest;
